import { HStack, Link } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { getDesignToken } from 'styles/constants';

export const CardContainer = HStack.withConfig({
  backgroundColor: getDesignToken('background-pattern'),
  borderRadius: 'lg',
  paddingY: '$3',
  paddingX: '$4',
  width: 'full',
  alignItems: 'center',
});

export const Price = withTypography({
  color: getDesignToken('text-disabled'),
  fontSize: 'sm',
  lineHeight: 'sm',
});

export const ItemName = withTypography({ fontFamily: 'heading', fontSize: 'md', mt: '$1' });

export const StyledLink = Link.withConfig({
  _web: {
    width: 'fit-content',
    cursor: 'pointer',
    _hover: {
      _text: {
        color: getDesignToken('color-tertiary'),
      },
    },
  },
});
